<div class="userManagementTableFooter">
  <div class="userManagementTableFooter__textContainer">
    <div class="userManagementTableFooter__text">
      {{ footerMessage }}
    </div>
  </div>
</div>
